import React from 'react';
export var MenuContext = /*#__PURE__*/React.createContext({
  navigation: null,
  enableIconPadding: false
});